module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921085649_T.a9e5afdd.jpg";